const CUSTOMER_ID_KEY = 'menu-maven-customer-id'

// Generate a UUID v4 with fallback for environments without crypto.randomUUID
function generateUUID(): string {
  // Check if crypto.randomUUID is available (modern browsers)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  
  // Fallback UUID generation for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function getCustomerId(): string {
  let customerId = localStorage.getItem(CUSTOMER_ID_KEY)
  if (!customerId) {
    customerId = generateUUID()
    localStorage.setItem(CUSTOMER_ID_KEY, customerId)
  }
  return customerId
}

export function clearCustomerId(): void {
  localStorage.removeItem(CUSTOMER_ID_KEY)
}

export function hasCustomerId(): boolean {
  return localStorage.getItem(CUSTOMER_ID_KEY) !== null
} 